
import { IconButton, Snackbar, Tooltip, Typography, Tab, Tabs } from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { useState, useEffect, useContext, useRef } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { Alert } from '@mui/lab';

import { AppContext } from '../../../../RoutesWithAuth';

import axios from '../../../common/AxiosConfig';

import { LoadingIndicator } from '../reports/reconcilationreport/MuiStyled';

import {  feedbackTimeout, v2UIRoutePath } from '../../../common/commons';

import CustomGrid from '../customgrid';

import moment from 'moment-timezone';

import DeleteDialog from '../admin/settings/DeleteDialog';

import FormGroup from '../FormGroup';

import { Close } from '@mui/icons-material';

import ViewFile from './ViewFile';

import { standardButtonStyle } from '../requestdetails/buttonStyles';
import PermissionButton from '../PermissionButton';
import { TRACKING_PERMISSIONS } from '../../../common/RolePermissions';

import { horizontalTabStyles } from '../sharedStyles';


const COLUMNS = [{
    name: "Request File Type",
    mapping: 'requestfiletype',
    width: 200,
}, {
    name: "Request File",
    mapping: 'requestfilename',
    width: 300,
}, {
    name: "Request Check File",
    mapping: 'requestcheckfile',
    width: 300,
}, {
    name: "Regenerate File",
    mapping: 'regeneratefile',
    width: 200,
    headerAlign: 'center',
    align: 'center',
}, {
    name: "Resend File",
    mapping: 'resendfile',
    width: 180,
    headerAlign: 'center',
    align: 'center',
}]

// Custom page Level Styling
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        background: '#f0f4f8',
        '& .linkNotavailable': {
            color: 'red'
        },

    },
    pageHeader: {
        fontSize: '1.2rem',
        fontWeight: 800,
        color: '#1e3a5f',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        padding: '16px 0 10px 16px',
        margin: 0,
        borderBottom: '2px solid #267db7',
        marginBottom: '12px',
        '& a': {
            color: '#1e3a5f',
            textDecoration: 'none',
            background: 'linear-gradient(90deg, #1e3a5f, #267db7)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            '&:hover': {
                background: 'linear-gradient(90deg, #267db7, #3b9edd)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
            },
        },
    },
    tabWrapper: {
        ...horizontalTabStyles.tabWrapper,
        margin: '0 16px',
    },
    tabBody: {
        ...horizontalTabStyles.tabBody,
        margin: '0 16px',
    },
    actionButton: {
        '& .MuiButton-label': {
            fontSize: '0.7rem'
        }
    },
    tableWrapper: {
        width: '100%',
        borderRadius: '10px',
        overflow: 'hidden',
        border: '1px solid #e2e8f0',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        '& table': {
            width: '100%',
            borderCollapse: 'collapse',
        },
        '& thead': {
            background: '#dee2e6',
        },
        '& th': {
            padding: '12px 16px',
            textAlign: 'center',
            color: '#202124',
            fontWeight: 600,
            fontSize: '0.85rem',
            borderRight: '1px solid #c8cbce',
            letterSpacing: '0.3px',
            '&:last-child': {
                borderRight: 'none',
            },
        },
        '& tbody tr': {
            background: '#fff',
            borderBottom: '1px solid #edf2f7',
            transition: 'background-color 0.2s ease',
            '&:nth-of-type(odd)': {
                background: '#f8fafc',
            },
            '&:hover': {
                background: '#f0f7ff',
            },
        },
        '& td': {
            padding: '12px 16px',
            textAlign: 'left',
            color: '#334155',
            fontSize: '0.85rem',
            borderRight: '1px solid #edf2f7',
            '&:last-child': {
                borderRight: 'none',
            },
        },
    },
    accordianTitle: {
        fontWeight: 'bold'
    },
    dialogWrapper: {
        width: '860px'
    },
    dialogheader: {
        textAlign: 'center',
        fontSize: '0.75rem',
        '& span': {
            fontWeight: 'bold'
        },
        '& .modelheader': {
            paddingBottom: '5px',
            fontWeight: 'bold'
        }
    },
    deleteDialogContext: {
        width: '300px',
        height: '90px',
        '& .errorMessage': {
            fontSize: '11px',
            color: 'red'
        },
        '& .MuiFormControl-root': {
            height: '100%',
            width: '100%',
        },
        '& .MuiInputLabel-root': {
            marginLeft: '10px',
            color: 'black',
            '& .MuiFormLabel-asterisk': {
                float: 'left',
                paddingRight: '2px',
                color: 'red'
            }
        },
        '& .MuiInputBase-root': {
            border: '1px solid #95a3bd',
            borderRadius: '10px',
            marginTop: '21px',
        },
        '& .MuiInput-underline:before,.MuiInput-underline:after,.MuiInput-underline:hover:not(.Mui-disabled):before': {
            border: '0px'
        }
    },
    formGroupWrapper: {
        marginTop: '4px',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'flex-end',
        '& .form-group': {
            marginBottom: '0',
        },
        '& .MuiOutlinedInput-root': {
            borderRadius: '8px',
            fontSize: '0.85rem',
            '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#267db7',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#267db7',
                borderWidth: '2px',
            },
        },
        '& label.ml-1': {
            fontSize: '0.85rem',
            color: '#1e3a5f',
            fontWeight: 600,
            letterSpacing: '0.3px',
        },
    },
    tabCloseIcon: {
        marginLeft: '10px',
        color: 'gray',
        fontSize: '1rem',
        marginTop: '-3px'
    }
}));

const DailyFeed = ({ tabActiveParam }) => {
    const classes = useStyles();
    const yesterday = moment(new Date()).subtract(1, 'days').format('YYYY-MM-DD')

    // State to handle the Main Tab Information
    const [activeTab, setActiveTab] = useState(0);
    const [dailyfeedData, setDailyFeedData] = useState([]);
    const [displayErrorMsg, setDisplayErrorMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [openDialog, setOpenDialog] = useState(false);
    const [dialogRowInfo, setDialogRowInfo] = useState();


    //state for maintaining form related data
    const [formData, setFormData] = useState({
        date: null
    });
    const location = useLocation();
    // State to handle the Progress status
    const [isInProgress, setIsInProgress] = useState(false);
    const [checkFile, setCheckFile] = useState();
    const [requestFile, setRequestFile] = useState();
    const [activeTabs, setActiveTabs] = useState([]);
    const [ingestApps, setIngestApps] = useState([]);

    const context = useContext(AppContext)
    const formGroupRef = useRef();


    const authToken = context.authToken.get

    useEffect(() => {
        if (location?.state?.fromredirection) {
            // resetting the Form when there is change in the Location state.
            formGroupRef.current.resetFormToDefaults();
            setFormData({
                date: yesterday
            })
            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.state?.fromredirection])

    useEffect(()=>{
        setFormData({
            date: yesterday
        })
        fetchData(yesterday)
          // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const fetchDataWithDelay = () => {
        setTimeout(
            function () {
                fetchData(formData.date);
            }, feedbackTimeout
        )
    }
    const fetchData = (date) => {
        console.log("API CALLED")
        setIsInProgress(true)

        axios.get(`apps/daily-feed?date=${moment(date).format("YYYY-MM-DD")}`, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            let dailyfeedResponse = res.data;
            // Separate FTP items (have requestfiletype) from ingest items (have appname)
            const ftpItems = dailyfeedResponse?.filter(r => r.requestfiletype) || [];
            const ingestItems = dailyfeedResponse?.filter(r => r.appname) || [];
            // Build ingest apps list: unique appids from FTP items + appname-based items
            const ftpAppMap = new Map();
            const ingestAppNames = { 5: 'CT-BI', 6: 'SXM', 11: 'SXM Audio' };
            ftpItems.forEach(item => {
                if (!ftpAppMap.has(item.appid)) {
                    ftpAppMap.set(item.appid, { appname: ingestAppNames[item.appid] || item.requestfiletype, appid: item.appid, last_run_time: item.last_run_time });
                }
            });
            // Merge: FTP-derived apps (CT-BI, SXM, SXM Audio) + API ingest items (Jira)
            const allIngestApps = [...ftpAppMap.values(), ...ingestItems];
            setIngestApps(allIngestApps);
            // Format FTP data for the grid
            const formattedFtp = ftpItems.map((_record, index) => ({
                ..._record,
                id: index + 1
            }));
            setDailyFeedData(formattedFtp);
            setIsInProgress(false)
        }).catch(err => {
            setIsInProgress(false)
        })
    }
    const handleClose = () => {
        setDisplayErrorMsg("");
        setSuccessMsg("");
    }
    const handleDialogClose = () => {
        setOpenDialog(false);
    }
    const handleDialogSubmit = () => {
        setOpenDialog(false);
        setIsInProgress(true)
        const additionalDetails = {};
        if (dialogRowInfo.rtd === true) {
            additionalDetails.rtd = true;
        }
        axios.post(`apps/daily-feed/resend`, {
            app_id: dialogRowInfo.appid,
            ...additionalDetails,
            date: formData.date,
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setSuccessMsg("File has been regenerated successfully!");
            fetchDataWithDelay();
        }).catch(err => {
            let errorMsg = "Failed to resend file!";
            if (err.response?.data.message) {
                errorMsg = err.response.data.message
            }
            setDisplayErrorMsg(errorMsg);
        }).finally(() => {
            setIsInProgress(false)

        })
    }
    const resendFile = (row) => {
        setDialogRowInfo(row);
        setOpenDialog(true)
    }
    const reGenerateFile = (rowInfo) => {
        setIsInProgress(true);
        const additionalDetails = {};
        if (rowInfo.rtd === true) {
            additionalDetails.rtd = true;
        }
        axios.post(`apps/daily-feed/regenerate`, {
            app_id: rowInfo.appid,
            ...additionalDetails,
            date: formData.date,
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            // Set validity and messages based on the response code
            if (res.status === 201) {
                setSuccessMsg(res.data.message)
            } else if (res.status === 204) {
                setDisplayErrorMsg("Requests in scope are not available for the selected date")
            } 
            fetchDataWithDelay();
        }).catch(err => {
            setDisplayErrorMsg("Failed to regenerate file!")
        }).finally(() => {

            setIsInProgress(false);
        })
    }
    const processIngestResponse = (app) => {
        setIsInProgress(true);
        if (app.appid === 'jira') {
            axios.post(`/apps/dispatch_request/jira_response`, {}, {
                headers: {
                    Authorization: authToken
                }
            }).then(res => {
                setSuccessMsg("Successfully initiated response processing")
                fetchDataWithDelay();
            }).catch(err => {
                setDisplayErrorMsg("Error encountered while initiating Jira response processing")
            }).finally(() => {
                setIsInProgress(false);
            })
            return;
        }
        axios.post(`/apps/daily-feed/response/${app.appid}`, {}, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            if (res.status === 500) {
                setDisplayErrorMsg(res.data.message);
            } else if (res.status === 200) {
                setSuccessMsg(res.data.message)
            }
            fetchDataWithDelay();
        }).catch(err => {
            setDisplayErrorMsg("Response process encountered an error")
        }).finally(() => {
            setIsInProgress(false);
        })
    }
    const handleFileClick = (row, columnMapping) => {
        const fileName = row[columnMapping];
        if (["NA", "File not found"].includes(fileName)) return;
        const isCheck = columnMapping === "requestcheckfile";
        let tabType = isCheck ? "CHECK" : "REQUEST";
        let activeTabIndex = activeTabs.indexOf(tabType);
        if (activeTabIndex === -1) {
            activeTabs.push(tabType);
            activeTabIndex = activeTabs.length + 1;
            setActiveTabs(activeTabs);
        } else {
            activeTabIndex = activeTabIndex + 2;
        }
        setActiveTab(activeTabIndex);
        const documentInfo = {
            ...row,
            selectedDate: formData.date,
            fileName: fileName
        };
        if (isCheck) {
            setCheckFile(documentInfo);
        } else {
            setRequestFile(documentInfo);
        }
    };
    const dataGridColumns = () => {
        return COLUMNS.map((column) => {
            if (column.mapping === "requestfilename") {
                column.renderCell = (params) => {
                    const val = params.row['requestfilename'];
                    if (["NA", "File not found"].includes(val)) {
                        return (<span className={`${val !== "NA" ? "linkNotavailable" : ""}`}>{val}</span>)
                    }
                    return (<Link onClick={(e) => { e.stopPropagation(); handleFileClick(params.row, 'requestfilename'); }}>{val}</Link>)
                }
            } else if (column.mapping === "requestcheckfile") {
                column.renderCell = (params) => {
                    const val = params.row['requestcheckfile'];
                    if (["NA", "File not found"].includes(val)) {
                        return (<span className={`${val !== "NA" ? "linkNotavailable" : ""}`}>{val}</span>)
                    }
                    return (<Link onClick={(e) => { e.stopPropagation(); handleFileClick(params.row, 'requestcheckfile'); }}>{val}</Link>)
                }
            } else if (column.mapping === "regeneratefile") {
                column.renderCell = (params) => {
                    return (<PermissionButton
                        permission={TRACKING_PERMISSIONS.REGENERATE_FILE}
                        variant="contained"
                        data-testid="regenerateFile"
                        sx={standardButtonStyle}
                        onClick={() => {
                            reGenerateFile(params.row)
                        }}
                    >
                        Regenerate File
                    </PermissionButton>)
                }
            } else if (column.mapping === "resendfile") {
                column.renderCell = (params) => {
                    return (<PermissionButton
                        permission={TRACKING_PERMISSIONS.RESEND_FILE}
                        variant="contained"
                        data-testid="resendFile"
                        sx={standardButtonStyle}
                        onClick={() => {
                            resendFile(params.row)
                        }}
                    >
                        Resend File
                    </PermissionButton>)
                }
            }
            return column
        });
    }
    return (
        <div className={classes.root}>
            {isInProgress && (<>
                <LoadingIndicator />
            </>)}
            <Snackbar open={!!displayErrorMsg} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert onClose={handleClose} severity="error">
                    {displayErrorMsg}
                </Alert>
            </Snackbar>
            <Snackbar open={!!successMsg} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert onClose={handleClose} severity="success">
                    {successMsg}
                </Alert>
            </Snackbar>
            <Typography variant="h6" className={classes.pageHeader}>
                <Link to={() => {
                    const autoId = Math.round(Math.random() * 1e5);
                    return {
                        pathname: v2UIRoutePath + "tracking/dailyfeed",
                        state: { fromredirection: autoId }
                    }
                }}>
                    DAILY FEED
                </Link>
            </Typography>
            <div className={classes.tabWrapper}>
            <Tabs
                variant="scrollable"
                aria-label="tabs"
                value={activeTab}
                onChange={(_event, newValue) => {
                    setActiveTab(newValue);

                }}
            >
                <Tab label="FTP SYSTEMS" />
                <Tab label="INGEST RESPONSE" />
                {activeTabs?.map((type) => {
                    if (type === "CHECK" && checkFile) {
                        return (<Tab label={(<span>
                            REQUEST CHECK FILE
                            <IconButton
                                className={classes.tabCloseIcon}
                                size="small"
                                aria-label="close"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveTab(0);
                                    setActiveTabs(activeTabs.filter((tab) => tab !== "CHECK"))
                                    setCheckFile(null);
                                }}
                            >
                                <Close fontSize="small" />
                            </IconButton>
                        </span>)} />)
                    } else if (requestFile) {
                        return (<Tab label={(<span>
                            REQUEST FILE
                            <IconButton
                                className={classes.tabCloseIcon}
                                size="small"
                                aria-label="close"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setActiveTab(0);
                                    setActiveTabs(activeTabs.filter((tab) => tab === "CHECK"))
                                    setRequestFile(null);
                                }}
                            >
                                <Close fontSize="small" />
                            </IconButton>
                        </span>)} />)
                    }
                    return null;
                })}
            </Tabs>
            </div>
            <div className={classes.tabBody}>
            {activeTab === 0 && (
                <>
                    <FormGroup
                        formWrapperClassName={classes.formGroupWrapper}
                        ref={formGroupRef}
                        fields={[{
                            type: 'date',
                            name: 'date',
                            defaultOption: (formData.date || yesterday ),
                            label: 'Select Date',
                            size: 4,
                            inputAdditionalProps: {
                                max: yesterday,
                                min: "2020-01-01",
                            }
                        }]}
                        disableFormActions={true}
                        customFormUpdates={(_formData) => {

                            // This Method is called when ever there is any change in the form fields
                            if (_formData.date !== formData.date) {
                                setFormData(_formData)
                                fetchData(_formData.date)
                            }

                        }}
                    />
                    <CustomGrid
                        columns={dataGridColumns()}
                        rows={dailyfeedData || []}
                        showFilterButton={false}
                    />
                </>
            )}
            {activeTab === 1 && (
                <div className={classes.tableWrapper}>
                    <table>
                        <thead>
                            <tr>
                                <th>Apps</th>
                                <th>Last Run (CST)</th>
                                <th>Process Response</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ingestApps.map((app, index) => (
                                <tr key={index}>
                                    <td>{app.appname}</td>
                                    <td>
                                        {app.last_run_time ? (
                                            <Tooltip title={moment.tz(app.last_run_time, 'MMMM Do, YYYY HH:mm:ss', 'America/Chicago').local().format('MMMM Do, YYYY HH:mm:ss')} arrow>
                                                <span>{app.last_run_time}</span>
                                            </Tooltip>
                                        ) : '—'}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <PermissionButton
                                            permission={TRACKING_PERMISSIONS.INGEST}
                                            variant="contained"
                                            data-testid={`ingest-${app.appid}`}
                                            sx={standardButtonStyle}
                                            disabled={isInProgress}
                                            onClick={() => processIngestResponse(app)}
                                        >
                                            Ingest
                                        </PermissionButton>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            {activeTabs?.map((_tab, index) => {
                let file = requestFile;
                if (_tab === "CHECK") {
                    file = checkFile
                }
                if (index + 2 === activeTab) { // +2 to account for FTP and JIRA SYSTEMS tabs
                    return (
                        <ViewFile
                            documentInfo={file}
                            is_check={_tab === "CHECK"}
                            displayErrorMsg={setDisplayErrorMsg}
                        />
                    )
                }
                return null

            })}
            </div>
            {openDialog && (<DeleteDialog
                openDeleteDialog={openDialog}
                handleDeleteDialogClose={handleDialogClose}
                title={"Confirm Resend to FTP"}
                handleDeleteDialogSubmit={handleDialogSubmit}
            >
                Do you really want to resend the file for {moment(formData?.date).format('MMM Do, YYYY')} to {dialogRowInfo?.requestfiletype} ?
            </DeleteDialog>)}
        </div>
    )
};

export default React.memo(DailyFeed);